var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.itensDataTable,"items-per-page":25}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }